/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import CodeEntry from "./CodeEntry";
import StringEntry from "./StringEntry";
import { displayStringFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import ReferenceEntry, { DisplayFromFHIRReference } from "./ReferenceEntry";
import UriEntry, { CreateHyperlink } from "./UriEntry";
import MarkdownEntry, { DisplayFromFHIRMarkdown } from "./MarkdownEntry";
import AttachmentEntry, { DisplayFromFHIRAttachment } from "./AttachmentEntry";
import ArrayEntry from "./ArrayEntry";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";
import { DateEntry } from "./PeriodEntry";

//to create a hyperlink to an absolute or relative URL in a Reference Datatype
/* REMOVED 2025-10-29
const ResourceReferenceHyperlink = ({ reference }) => {
  if (reference) {
    if (typeof reference.reference === "string" && reference.reference.trim()) {
      return <CreateHyperlink url={reference.reference} display={displayStringFromFHIRReference(reference)} openInNewTab={true} />;
    } else if (reference.identifier) {
      let fli;
      //check if FEvIR Linking Identifier is found
      if (reference.identifier.system?.toLowerCase() === "https://fevir.net/fli" || reference.identifier.type?.text === "FEvIR Linking Identifier") {
        fli = reference.identifier.value;
      }
      if (fli) {
        return <CreateHyperlink url={"/FLI/" + fli} display={displayStringFromFHIRReference(reference)} openInNewTab={true} />;
        //return <a href={"/FLI/" + fli} target="_blank" rel="noopener noreferrer">{fli}</a>;
      }
    }
    return <>{displayStringFromFHIRReference(reference)}</>;
  }
  return <></>;
}
  */

const DisplayFromFHIRRelatedArtifact = ({ relatedArtifact, containedResourceDictionary = {} }) => {
  if (relatedArtifact) {
    let type = relatedArtifact.type || "";
    if (typeof type === 'object') {
      type = "[ERROR: RelatedArtifact.type is not in string form.]";
    }
    let classifierDisplay = "";
    if (relatedArtifact.classifier?.length > 0) {
      let classifierList = [];
      for (let classifierEntry in relatedArtifact.classifier) {
        let classifierString = displayStringFromFHIRCodeableConcept(relatedArtifact.classifier[classifierEntry]);
        if (classifierString.substring(0, 81) === "Quotation (coded as: quotation from http://hl7.org/fhir/provenance-entity-role); ") {
          classifierString = "Quotation (coded as: quotation from http://hl7.org/fhir/provenance-entity-role); \"" + classifierString.substring(81) + "\"";
        }
        classifierList.push(classifierString);
      }
      classifierDisplay = classifierList.join('; ') || "";
    }
    let label = relatedArtifact.label || "";
    let display = relatedArtifact.display || "";
    let citation = relatedArtifact.citation || "";
    let document = relatedArtifact.targetAttachment || relatedArtifact.document || "";
    let canonical = relatedArtifact.targetUri || relatedArtifact.targetCanonical || relatedArtifact.resource || "";
    let resourceReference = "";
    if (relatedArtifact.targetReference) {
      resourceReference = <DisplayFromFHIRReference reference={relatedArtifact.targetReference}
        containedResourceJson={relatedArtifact.targetReference.reference && containedResourceDictionary[relatedArtifact.targetReference.reference]} />;
    }
    if (relatedArtifact.resourceReference) {
      resourceReference = <DisplayFromFHIRReference reference={relatedArtifact.resourceReference}
        containedResourceJson={relatedArtifact.resourceReference.reference && containedResourceDictionary[relatedArtifact.resourceReference.reference]} />;
    }
    let publicationStatus = relatedArtifact.publicationStatus || "";
    let publicationDate = relatedArtifact.publicationDate || "";
    let targetMarkdown = relatedArtifact.targetMarkdown || "";
    return <div style={{ marginLeft: "24px" }}>
      <p><b>Relationship Type: </b> {type}</p>
      {label && <p><b>Label: </b> {label}</p>}
      {display && <p><b>Description: </b> {display}</p>}
      {citation && <span><b>Citation: </b> <DisplayFromFHIRMarkdown markdown={citation} /></span>}
      {targetMarkdown && <span><b>Description: </b> <DisplayFromFHIRMarkdown markdown={targetMarkdown} /></span>}
      {classifierDisplay && <p><b>Classifier(s): </b> {classifierDisplay}</p>}
      {canonical && <p><b>URL: </b> <CreateHyperlink url={canonical} display={canonical} openInNewTab={true} /></p>}
      {document && <DisplayFromFHIRAttachment attachment={document} />}
      {resourceReference && <p><b>Resource Reference: </b> {resourceReference}</p>}
      {publicationStatus && <p><b>Publication Status: </b> {publicationStatus}</p>}
      {publicationDate && <p><b>Publication Date: </b> {publicationDate}</p>}
    </div>
  } else {
    return <></>
  }
}

const RelatesToDatatypeSelector = ({ relatedArtifactDatatypeState, setRelatedArtifactDatatypeState,
  referenceAllowedDatatypes
}) => {
  return <div>
    <p style={{ marginBottom: "0px" }}><b>Datatype for the referenced item:</b></p>
    <FormControl>
      <FormLabel id="radiodatatypeselector-label"
        style={{ color: "#000000", paddingBottom: "6px" }}>Choose one way to define the referenced item. Use Reference for FHIR Resources on the FEvIR Platform. <i>(If you Update with a different datatype, you will lose previous reference data.)</i></FormLabel>
      <RadioGroup aria-label="radiodatatypeselector" name={"radiodatatypeselector-reference"}
        value={relatedArtifactDatatypeState}
        onChange={(e) => { setRelatedArtifactDatatypeState(e.target.value); }}>
        {referenceAllowedDatatypes.map((allowedDatatype, allowedDatatypeIndex) => {
          return <FormControlLabel
            key={allowedDatatypeIndex}
            value={allowedDatatype}
            control={<Radio color="primary" style={{ paddingTop: "4px", paddingBottom: "4px" }} />}
            name="radio-button-control"
            color="default"
            inputprops={{ 'aria-label': allowedDatatype }}
            label={<span style={{ textAlign: 'center' }}><b>{allowedDatatype}</b></span>}
            style={{ paddingLeft: "16px" }}
          />
        })}
      </RadioGroup>
    </FormControl></div>
};

const EditPublicationStatus = ({ setEditPublicationStatusState, relatedArtifactState }) => {
  return <span className={"unselectable"} style={{ cursor: "pointer" }}
    onClick={() => { setEditPublicationStatusState(true) }}>
    {(relatedArtifactState.publicationStatus || relatedArtifactState.publicationDate) ? <>✎ Edit Publication Status/Date</> : <>➕ Add Publication Status/Date</>}
  </span>
};

const relatedArtifactDotPublicationStatusValues = ['draft', 'active', 'retired', 'unknown'];
const RelatedArtifactEntry = ({ elementName, fieldLabel, startingValue, setResourceState,
  allowedTypeValues, startCollapsed, relatesToClassifierValueSet = [],
  containedResourceDictionary = {} }) => {

  if (allowedTypeValues === "FHIR" || !allowedTypeValues) {
    allowedTypeValues = ['documentation', 'justification', 'citation', 'predecessor', 'successor',
      'derived-from', 'depends-on', 'composed-of', 'part-of'].sort();
  }

  const [relatedArtifactState, setRelatedArtifactState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);
  const [relatedArtifactDatatypeState, setRelatedArtifactDatatypeState] = useState('none');
  const [editPublicationStatusState, setEditPublicationStatusState] = useState(false);

  const referenceAllowedDatatypes = ['Attachment', 'uri', 'Reference'];

  useEffect(() => {
    let startingRelatedArtifact = {
      "type": "", "classifier": [], "label": "", "display": "", "citation": "",
      "document": "", "resource": "", "resourceReference": "", "publicationStatus": "", "publicationDate": ""
    };
    let startingRelatedArtifactDatatype = 'none';
    if (startingValue) {
      if (startingValue.extension) { startingRelatedArtifact.extension = startingValue.extension; }
      if (startingValue.type) { startingRelatedArtifact.type = startingValue.type; }
      if (startingValue.classifier) { startingRelatedArtifact.classifier = startingValue.classifier; }
      if (startingValue.label) { startingRelatedArtifact.label = startingValue.label; }
      if (startingValue.display) { startingRelatedArtifact.display = startingValue.display; }
      if (startingValue.citation) { startingRelatedArtifact.citation = startingValue.citation; }
      if (startingValue.document) {
        startingRelatedArtifact.document = startingValue.document;
        startingRelatedArtifactDatatype = 'Attachment';
      }
      if (startingValue.resource) {
        startingRelatedArtifact.resource = startingValue.resource;
        startingRelatedArtifactDatatype = 'uri';
      }
      if (startingValue.resourceReference) {
        startingRelatedArtifact.resourceReference = startingValue.resourceReference;
        startingRelatedArtifactDatatype = 'Reference';
      }
      if (startingValue.publicationStatus) { startingRelatedArtifact.publicationStatus = startingValue.publicationStatus; }
      if (startingValue.publicationDate) { startingRelatedArtifact.publicationDate = startingValue.publicationDate; }
    }
    setRelatedArtifactState(JSON.parse(JSON.stringify(startingRelatedArtifact)));
    setRelatedArtifactDatatypeState(startingRelatedArtifactDatatype);
  }, []);

  useEffect((() => {
    if (Object.keys(relatedArtifactState).length) {
      let newRelatedArtifact = {};
      if (relatedArtifactState.extension) { newRelatedArtifact.extension = relatedArtifactState.extension; }
      if (relatedArtifactState.type) { newRelatedArtifact.type = relatedArtifactState.type; }
      if (relatedArtifactState.classifier !== null && relatedArtifactState.classifier !== undefined && relatedArtifactState.classifier.length !== 0) {
        newRelatedArtifact.classifier = relatedArtifactState.classifier;
      }
      if (relatedArtifactState.label) { newRelatedArtifact.label = relatedArtifactState.label; }
      if (relatedArtifactState.display) { newRelatedArtifact.display = relatedArtifactState.display; }
      if (relatedArtifactState.citation) { newRelatedArtifact.citation = relatedArtifactState.citation; }
      if (relatedArtifactDatatypeState === "Attachment" && relatedArtifactState.document && Object.keys(relatedArtifactState.document).length) {
        newRelatedArtifact.document = relatedArtifactState.document;
      }
      if (relatedArtifactDatatypeState === "uri" && relatedArtifactState.resource) { newRelatedArtifact.resource = relatedArtifactState.resource; }
      if (relatedArtifactDatatypeState === "Reference" && relatedArtifactState.resourceReference && Object.keys(relatedArtifactState.resourceReference).length) {
        newRelatedArtifact.resourceReference = relatedArtifactState.resourceReference;
      }
      if (relatedArtifactState.publicationStatus) { newRelatedArtifact.publicationStatus = relatedArtifactState.publicationStatus; }
      if (relatedArtifactState.publicationDate) { newRelatedArtifact.publicationDate = relatedArtifactState.publicationDate; }
      if (Object.keys(newRelatedArtifact).length === 0) {
        newRelatedArtifact = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newRelatedArtifact }; });
    }
  }), [relatedArtifactState, relatedArtifactDatatypeState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRRelatedArtifact relatedArtifact={startingValue}
          containedResourceDictionary={containedResourceDictionary} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(relatedArtifactState).length > 0) {
    return <>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        {allowedTypeValues ?
          <CodeEntry elementName='type' fieldLabel='Relationship Type'
            startingValue={relatedArtifactState.type} setResourceState={setRelatedArtifactState}
            allowedValues={allowedTypeValues} dataEntryStyle='dropdownsearch' />
          :
          <StringEntry elementName='type' fieldLabel='Relationship Type' startingValue={relatedArtifactState.type} setResourceState={setRelatedArtifactState} />
        }
        <p style={{ marginBottom: "0px" }}><b>The Referenced Item:</b></p>
        <div style={{ marginLeft: "24px" }}>
          <RelatesToDatatypeSelector relatedArtifactDatatypeState={relatedArtifactDatatypeState}
            setRelatedArtifactDatatypeState={setRelatedArtifactDatatypeState}
            referenceAllowedDatatypes={referenceAllowedDatatypes} />
          {relatedArtifactDatatypeState === "Attachment" &&
            <AttachmentEntry elementName='document' setResourceState={setRelatedArtifactState}
              startCollapsed={relatedArtifactState.document}
              fieldLabel={'Attachment for ' + fieldLabel} startingValue={relatedArtifactState.document} />}
          {relatedArtifactDatatypeState === "uri" &&
            <UriEntry elementName='resource' setResourceState={setRelatedArtifactState}
              fieldLabel={'Canonical URI for ' + fieldLabel} startingValue={relatedArtifactState.resource} />}
          {relatedArtifactDatatypeState === "Reference" &&
            <ReferenceEntry elementName='resourceReference' setResourceState={setRelatedArtifactState}
              startCollapsed={relatedArtifactState.resourceReference} enableCreation={true}
              containedResourceDictionary={containedResourceDictionary}
              fieldLabel={'Resource Reference for ' + fieldLabel}
              startingValue={relatedArtifactState.resourceReference} />
          }
        </div>
        <p style={{ marginBottom: "0px" }}><b>Classifiers of the Referenced Item:</b></p>
        <ArrayEntry datatype='CodeableConcept' elementName='classifier' fieldLabel='Target Classifier'
          valueSet={relatesToClassifierValueSet} startingValue={relatedArtifactState.classifier}
          setResourceState={setRelatedArtifactState} />
        <br /> <br />
        <span><b>Label: </b> (e.g. 1, 2, 3)</span>
        <StringEntry elementName='label' setResourceState={setRelatedArtifactState}
          fieldLabel={'Label for ' + fieldLabel} startingValue={relatedArtifactState.label} />
        <br /> <br />
        <span><b>Display: </b> (brief description)</span>
        <StringEntry elementName='display' setResourceState={setRelatedArtifactState}
          fieldLabel={'Display of ' + fieldLabel} startingValue={relatedArtifactState.display} />
        <br /> <br />
        <span><b>Citation: </b> (fuller detail)</span>
        <MarkdownEntry elementName='citation' setResourceState={setRelatedArtifactState}
          fieldLabel={'Citation for ' + fieldLabel} startingValue={relatedArtifactState.citation} />
        <br />
        {!editPublicationStatusState &&
          <EditPublicationStatus setEditPublicationStatusState={setEditPublicationStatusState}
            relatedArtifactState={relatedArtifactState} />}
        {editPublicationStatusState && <>
          <CodeEntry elementName='publicationStatus' setResourceState={setRelatedArtifactState}
            fieldLabel={'Publication Status for ' + fieldLabel} startingValue={relatedArtifactState.publicationStatus}
            allowedValues={relatedArtifactDotPublicationStatusValues} />
          <DateEntry elementName='publicationDate' setResourceState={setRelatedArtifactState}
            fieldLabel={'Publication Date for ' + fieldLabel} startingValue={relatedArtifactState.publicationDate} width={"300px"} />
        </>}
      </div>
    </>
  }
}

export default RelatedArtifactEntry;

export { DisplayFromFHIRRelatedArtifact };